<template>
  <div>



    <main role="main">


      <div class="container">

        <div class="row mt-3">
          <div class="col-md-12">
            <h1>{{$t('text.globals.error')}}!</h1>
          </div>
        </div>

      </div>


    </main>


  </div>
</template>

<script type="text/javascript">
  import Vue from 'vue';



  export default {
    name: 'Error',
    components: {

    },

    beforeCreate: function() {
      document.body.className = 'error';
    }

  };
</script>



// WEBPACK FOOTER //
// src/pages/Error.vue